import React from "react";
import classes from "../css/InsufficientPages.module.css";

const InsufficientFundsPage = () => {
  return (
    <div className={`cptpl_page ${classes.wrapper}`}>
      <input
        type="hidden"
        value="20221206"
        name="cptpl_template"
        className="cptpl_template"
      />

      <div className={classes.card}>
        {/* Logo + Heading */}
        <div className={classes.logoHeading}>
          <img
            src="https://vd-kickwin.gameit.in/assets/images/soccer-ball.png"
            alt="Kick n Winn"
            className={`cptpl_logo cptpl_logo_static ${classes.logo}`}
            crossOrigin="anonymous"
          />
          <h3 className={`cptpl_service ${classes.heading}`}>
            Kick n Winn
          </h3>
        </div>

        {/* Message */}
        <div className={classes.block_content}>
          <p className={classes.subtext}>
            Insufficient Funds. Please top up to continue.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InsufficientFundsPage;
